"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const core_1 = require("@material-ui/core");
const RenderRadioField = (props) => {
    const { field: { value, name }, onValueChange, text, checkedValue, defaultValue, textStyle, ...otherProps } = props;
    return (react_1.default.createElement(core_1.Box, { style: { display: 'flex', alignItems: 'center' } },
        react_1.default.createElement(core_1.Radio, Object.assign({ checked: defaultValue ? defaultValue : value === checkedValue, onChange: onValueChange, name: name, color: "primary" }, otherProps)),
        react_1.default.createElement(core_1.Typography, { variant: 'body1', style: textStyle }, text)));
};
RenderRadioField.defaultProps = {
    checkedValue: true,
};
RenderRadioField.propTypes = {
    field: prop_types_1.default.any.isRequired,
    onValueChange: prop_types_1.default.any.isRequired,
    text: prop_types_1.default.string.isRequired,
    checkedValue: prop_types_1.default.any,
    defaultValue: prop_types_1.default.bool,
    textStyle: prop_types_1.default.any,
};
exports.default = RenderRadioField;
